module.exports = __webpack_public_path__ + "img/fs_lola-bold-webfont.45baaeef.svg";